import { Component } from '@angular/core';

@Component({
  selector: 'app-snack-bar',
  templateUrl: './snack-bar.component.html',
  styleUrls: ['./snack-bar.component.scss']
})
export class SnackBarComponent {
  title = '';
  message = '';
  type: 'success' | 'error' = 'success';
  isVisible = false;

  showMessage(
    title: string,
    message: string,
    type: 'success' | 'error' = 'success',
    duration: number = 3000
  ): void {
    if (!this.isVisible) {
      this.title = title;
      this.message = message;
      this.type = type;
      this.isVisible = true;

      setTimeout(() => {
        this.hide();
      }, duration);
    }
  }

  hide(): void {
    this.isVisible = false;
  }
}